export const themeOptionFactory = (theme) => ({
  components: {
    AppDesktopFeatureDialog: {
      styleOverrides: {
        featureListRoot: {
          minHeight: "120px",
          maxHeight: "340px",
          overflow: "hidden auto",
          "& .FeatureListDetail-listItem": {
            padding: theme.spacing(1.5, 0),
          },
        },
      },
    },
    FeatureListDetail: {
      styleOverrides: {
        list: {
          padding: 0,
        },
        listItem: {
          "&.FeatureListDetail-listItem": {
            padding: theme.spacing(1.5, 3),
            alignItems: "stretch",
            ".MuiListItemText-primary": {
              fontSize: "1rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 1,
            },
            ".MuiListItemText-secondary": {
              display: "none",
            },
          },
        },
      },
    },
    VuiDescriptionList: {
      styleOverrides: {
        root: {
          alignItems: "start",
        },
      },
    },
    FeatureSummary: {
      styleOverrides: {
        root: {
          gap: theme.spacing(2),
        },
        locationText: {
          "& .MuiTypography-root:first-of-type": {
            display: "none",
          },
          "& .MuiTypography-root:last-of-type": {
            color: theme.palette.primary.dark,
            textTransform: "uppercase",
          },
        },
        venueLogoContainer: {
          display: "none",
        },
        logoImage: {
          width: "100%",
          height: "100%",
        },
        categoryText: {
          color: theme.palette.grey[700],
        },
        operationTimeLabel: {
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(0.25),
          "& .MuiTypography-root:first-of-type": {
            color: theme.palette.grey[700],
            fontWeight: 400,
            textTransform: "capitalize",
          },
          "& .MuiTypography-root:last-of-type": {
            color: theme.palette.grey[700],
            fontWeight: 400,
          },
        },
        categoryIcon: {
          width: "100%",
          height: "100%",
          padding: theme.spacing(2),
        },
      },
    },
    OccupantImageCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          display: "flex",
          width: "100%",
          flexDirection: "column",
          height: 202,
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          "&.section-card": {
            border: "1px solid transparent",
            background:
              "linear-gradient(181deg, rgba(255, 250, 237, 0.44) 10.64%, rgba(217, 195, 142, 0.44) 158.34%) padding-box, linear-gradient(white, white) padding-box, linear-gradient(to right, #FFFAED, #D9C38E) border-box",
            backgroundClip: "padding-box, padding-box, border-box",
            ".OccupantImageCard-levelContainer": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        },
        header: {
          boxShadow: theme.shadows[1],
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "100%",
          },
          "& .MuiAvatar-img": {
            objectFit: "contain",
          },
          "& .MuiSvgIcon-root": {
            width: 48,
            height: 48,
          },
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          position: "absolute",
          padding: theme.spacing(1),
          zIndex: 1,
          top: 0,
        },
        zoneChip: {
          padding: theme.spacing(0.5, 1),
          height: 30,
          borderRadius: "9999px",
          border: `0.4px solid ${theme.palette.primary.dark}`,
          backgroundColor: theme.palette.common.white,
          marginRight: "auto",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: theme.palette.primary.dark,
            textTransform: "capitalize",
          },
        },
        highlightChip: {
          padding: theme.spacing(0.5, 1),
          height: 30,
          borderRadius: "9999px",
          backgroundColor: theme.palette.primary.dark,
          marginLeft: "auto",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: theme.palette.common.white,
            textTransform: "capitalize",
          },
        },
        headerCover: {
          width: "100%",
          height: 121,
          backgroundColor: "#BDBDBD",
        },
        contentContainer: {
          display: "flex",
          justifyContent: "space-between",
          height: "100%",
          position: "relative",
          gap: theme.spacing(0.5),
          padding: theme.spacing(0.5),
          "& .MuiTypography-root": {
            lineHeight: 1.25,
          },
        },
        adornmentContainer: {
          display: "flex",
          alignItems: "end",
          position: "absolute",
          bottom: 0,
          right: 0,
        },
        adornment: {
          background: "#A4A4AD",
          width: 31,
          height: 25,
          color: theme.palette.common.white,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderTopLeftRadius: "20px",
          "& .MuiTypography-root": { fontSize: "0.75rem", fontWeight: 400 },
        },
        logo: {
          display: "flex",
          gap: theme.spacing(0.5),
          "& .MuiAvatar-root": {
            width: 40,
            height: 40,
            borderRadius: "4px",
          },
        },
        textContainer: {
          width: "100%",
        },
        title: {
          color: theme.palette.text.primary,
          fontSize: "0.875rem",
          fontWeight: 700,
          flex: 1,
          textTransform: "capitalize",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
        subtitleContainer: {
          width: "100%",
          gap: theme.spacing(2),
          ":before": {
            content: "''",
            width: "93px",
            borderTop: `1px solid ${theme.palette.divider}`,
            marginTop: "4px",
            top: 0,
          },
        },
        subtitle: {
          fontSize: "0.75rem",
          fontWeight: 400,
          color: theme.palette.text.primary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
        },
      },
    },
    DirectionSearchContainer: {
      styleOverrides: {
        suggestionList: {
          padding: 0,
        },
      },
    },
    SuggestionListItem: {
      styleOverrides: {
        secondaryWrapper: {
          display: "flex",
          gap: theme.spacing(0.75),
        },
        zoneChip: {
          padding: theme.spacing(0.5, 1),
          height: 18,
          borderRadius: 48,
          border: `0.4px solid ${theme.palette.primary.dark}`,
          backgroundColor: theme.palette.common.white,
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: theme.palette.primary.dark,
            textTransform: "capitalize",
          },
        },
      },
    },
  },
})
